import { defineBlock, ChildrenBlock } from '@smartfire/js-block-engine';

function FormHeader() {
    return (
        <ChildrenBlock
            gutenbergEditorConfig={{
                allowedBlocks: ['core/paragraph', 'core/heading', 'core/list', 'smartfire/button', 'smartfire/spacer'],
                template: [['core/heading'], ['core/paragraph']],
                templateLock: false,
            }}
        />
    );
}

export default defineBlock({
    Block: FormHeader,
    smartProps: {},
    setup: {
        title: 'Form header',
        parent: ['smartfire/contact---form'],
    },
});
